import { MigrationPeriod, MigrationWave, StartDayOption } from '@amzn/awscat-portfolio-assessment-types';
import { IsBoolean, IsInt, IsOptional, Max, MaxLength, Min } from 'class-validator';

import { toShortDate } from '../../../common/DateDisplay';
import { constants } from '../../../common/Localization';
import { IsEarlierThan, IsEarlierThanDate, IsLaterThan, IsLaterThanDate } from '../../../common/validator/DateValidator';
import { EARLIEST_WAVE_DATE, LATEST_WAVE_DATE, MAX_COMMENT_LENGTH, MAX_WAVE_CAPACITY } from './constants';
export interface RemoveFromWaveState {
    visible: boolean;
    groupId: string;
    groupName: string;
    waveId: string;
    waveName: string;
}

export interface DeleteWaveState {
    visible: boolean;
    waveId: string;
    waveName: string;
}

export interface CreateOrEditWaveState {
    visible: boolean;
    waveToEdit?: MigrationWave;
    waveToSave?: WaveToSave;
    isInvalid: boolean;
}

export interface AutoCreateWaveState {
    migrationPeriodToSave?: MigrationPeriodToSave;
    isInvalid: boolean;
    previewLoading: boolean;
    previewWaves: MigrationWave[];
    previewErrMsg: string;
}

export class MigrationPeriodToSave implements Record<string, unknown>, Partial<MigrationPeriod> {
    constructor() {
        this.timezoneOffset = new Date().getTimezoneOffset();
    }

    @IsOptional()
    @IsInt()
    @Min(1)
    @Max(100)
    waveDurationInWeeks?: number;

    @IsOptional()
    @IsInt()
    @Min(1)
    @Max(100)
    numberOfWaves?: number;

    @IsOptional()
    @IsEarlierThan('endDate', {
        message: constants.START_DATE_SHOULD_BE_EARLIER_THAN_END_DATE,
    })
    @IsLaterThanDate(EARLIEST_WAVE_DATE, {
        message: `${constants.DATE_SHOULD_BE_LATER_THAN} ${toShortDate(EARLIEST_WAVE_DATE)}`,
    })
    startDate?: Date;

    @IsOptional()
    @IsLaterThan('startDate', {
        message: constants.END_DATE_SHOULD_BE_LATER_THAN_START_DATE,
    })
    @IsEarlierThanDate(LATEST_WAVE_DATE, {
        message: `${constants.DATE_SHOULD_BE_EARLIER_THAN} ${toShortDate(LATEST_WAVE_DATE)}`,
    })
    endDate?: Date;

    @IsOptional()
    @Min(0)
    @Max(MAX_WAVE_CAPACITY)
    applicationCapacity?: number;

    @IsOptional()
    @Min(0)
    @Max(MAX_WAVE_CAPACITY)
    serverCapacity?: number;

    @IsOptional()
    @Min(0)
    @Max(MAX_WAVE_CAPACITY)
    databaseCapacity?: number;

    startDayOption?: StartDayOption;

    timezoneOffset?: number;

    deleteExistingWaves?: boolean;

    [key: string]: unknown;
}

export class WaveToSave implements Record<string, unknown>, Partial<MigrationWave> {
    @IsOptional()
    name?: string;

    @IsOptional()
    @MaxLength(MAX_COMMENT_LENGTH)
    comment?: string;

    @IsOptional()
    @IsEarlierThan('endDate', {
        message: constants.START_DATE_SHOULD_BE_EARLIER_THAN_END_DATE,
    })
    @IsLaterThanDate(EARLIEST_WAVE_DATE, {
        message: `${constants.DATE_SHOULD_BE_LATER_THAN} ${toShortDate(EARLIEST_WAVE_DATE)}`,
    })
    startDate?: Date;

    @IsOptional()
    @IsLaterThan('startDate', {
        message: constants.END_DATE_SHOULD_BE_LATER_THAN_START_DATE,
    })
    @IsEarlierThanDate(LATEST_WAVE_DATE, {
        message: `${constants.DATE_SHOULD_BE_EARLIER_THAN} ${toShortDate(LATEST_WAVE_DATE)}`,
    })
    endDate?: Date;

    @IsOptional()
    @Min(0)
    @Max(MAX_WAVE_CAPACITY)
    applicationCapacity?: number;

    @IsOptional()
    @Min(0)
    @Max(MAX_WAVE_CAPACITY)
    serverCapacity?: number;

    @IsOptional()
    @Min(0)
    @Max(MAX_WAVE_CAPACITY)
    databaseCapacity?: number;

    @IsBoolean()
    closed?: boolean;

    [key: string]: unknown;
}
